import React from "react";
import { useController } from "react-hook-form";
import { DatePickerInput } from "@/components/atoms/DatePickerInput";
import { FormInputProps } from "../FormInput";

type StringDateFormInputProps = Omit<FormInputProps, "onChange" | "value"> & {
    value?: string;
    onChange?: (value: string) => void;
    fromYear?: number;
    toYear?: number;
};

export const FormDateInput: React.FC<StringDateFormInputProps> = ({
    name,
    control,
    label,
    inputSize = "md",
    disabled = false,
    className,
    fromYear,
    toYear,
    ...rest
}) => {
    const {
        field: { onChange, value },
        fieldState: { error },
    } = useController({ name, control });

    const handleDateChange = (date: string) => {
        onChange(date);
    };
    console.log(name, value);

    return (
        <div className={className}>
            <DatePickerInput
                value={value}
                onChange={handleDateChange}
                label={label}
                inputSize={inputSize}
                disabled={disabled}
                fromYear={fromYear}
                toYear={toYear}
                {...rest}
            />
            {error && (
                <p className="text-red-600 text-sm mt-1" role="alert">
                    {error.message}
                </p>
            )}
        </div>
    );
};

